const { getDebugMode, getEnvironment } = require("../helpers/methods");
const { onMessage, sendMessage, hasParentFrame } = require("./frame-manager");

let HAS_LOCALSTORAGE = false;

try {
	window.localStorage.getItem("noop");
	HAS_LOCALSTORAGE = true;
} catch (e) {}

const getLocalStorageItemName = (name, appId) => {
	if (!name || !appId) {
		throw new Error("Please provided all the required parameters.");
	}

	if (getDebugMode()) {
		console.log("getLocalStorageItemName", `${name}_${appId}_${getEnvironment().NAME}`);
	}

	return `${name}_${appId}_${getEnvironment().NAME}`;
};

function set(name, data, expiresAt, appId) {
	if (!name || !data || !expiresAt || !appId) {
		throw new Error("Please provided all the required parameters.");
	}

	expiresAt = 1000 * expiresAt + Date.now();

	if (HAS_LOCALSTORAGE) {
		if (getDebugMode()) {
			console.log("set", getLocalStorageItemName(name, appId));
		}

		try {
			localStorage.setItem(getLocalStorageItemName(name, appId), JSON.stringify({ data, expiresAt, appId }));
		} catch (error) {
			console.log(error);

			localStorage.clear();

			localStorage.setItem(getLocalStorageItemName(name, appId), JSON.stringify({ data, expiresAt, appId }));
		}
	} else if (hasParentFrame) {
		sendMessage("storage:set", { name, data, expiresAt, appId });
	}
}

function remove(name, appId) {
	if (!name || !appId) {
		throw new Error("Please provided all the required parameters.");
	}

	if (HAS_LOCALSTORAGE) {
		if (getDebugMode()) {
			console.log("remove", getLocalStorageItemName(name, appId));
		}

		localStorage.removeItem(getLocalStorageItemName(name, appId));
	} else if (hasParentFrame) {
		sendMessage("storage:remove", name, appId);
	}
}

async function get(name, appId) {
	if (!name || !appId) {
		throw new Error("Please provided all the required parameters.");
	}

	let store = null;

	if (HAS_LOCALSTORAGE) {
		try {
			if (getDebugMode()) {
				console.log("get", getLocalStorageItemName(name, appId));
			}

			store = JSON.parse(window.localStorage.getItem(getLocalStorageItemName(name, appId)));
		} catch (e) {}
	} else if (hasParentFrame) {
		store = await sendMessage("storage:get", name, appId);
	}

	if (!store) {
		if (getDebugMode()) {
			console.log("store is null");
		}

		return null;
	}

	const { expiresAt } = store;

	if (!expiresAt || (expiresAt && expiresAt - Date.now() <= 0)) {
		if (getDebugMode()) {
			console.log("remove after expiresAt");
		}

		remove(name, appId);

		return null;
	}

	return store;
}

onMessage("storage:set", ({ name, data, expiresAt, appId }) => set(name, data, expiresAt, appId));
onMessage("storage:get", ({ name, appId }) => get(name, appId));
onMessage("storage:remove", ({ name, appId }) => remove(name, appId));

module.exports = storage = {
	set,
	get,
	remove
};
